import { render, staticRenderFns } from "./ItemMeal.vue?vue&type=template&id=cafe2160&scoped=true&"
import script from "./ItemMeal.vue?vue&type=script&lang=js&"
export * from "./ItemMeal.vue?vue&type=script&lang=js&"
import style0 from "./ItemMeal.vue?vue&type=style&index=0&id=cafe2160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafe2160",
  null
  
)

export default component.exports